interface DurationIconProps {
  width?: number;
  height?: number;
  fill?: string;
}

export function DurationIcon({width, height, fill}: DurationIconProps) {
  return (
    <svg
      width={width ?? 24}
      height={height ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 4C9.87824 4 7.8434 4.84284 6.34307 6.34307C4.84284 7.8434 4 9.87827 4 12C4 14.1217 4.84284 16.1566 6.34307 17.6569C7.8434 19.1572 9.87827 20 12 20C14.1217 20 16.1566 19.1572 17.6569 17.6569C19.1572 16.1566 20 14.1217 20 12C20 10.5957 19.6304 9.21622 18.9282 8.00005C18.2261 6.78388 17.2162 5.774 16 5.07187C14.7839 4.36973 13.4044 4.00009 12.0001 4.00009L12 4ZM17.3333 12.5332H12C11.8586 12.5332 11.7229 12.477 11.6229 12.377C11.5229 12.2771 11.4667 12.1413 11.4667 11.9999V6.66664C11.4667 6.47604 11.5683 6.29998 11.7333 6.20474C11.8983 6.10951 12.1017 6.10951 12.2667 6.20474C12.4317 6.29998 12.5333 6.47605 12.5333 6.66664V11.4666H17.3333C17.5239 11.4666 17.6999 11.5682 17.7952 11.7332C17.8904 11.8982 17.8904 12.1016 17.7952 12.2666C17.6999 12.4316 17.5239 12.5332 17.3333 12.5332Z"
        fill={fill ?? '#877978'}
      />
    </svg>
  );
}
